import { render, staticRenderFns } from "./PriceRuleTable.vue?vue&type=template&id=29d3eee8"
import script from "./PriceRuleTable.vue?vue&type=script&lang=js"
export * from "./PriceRuleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports